import { render } from "./reviewTrustForm.vue?vue&type=template&id=739c4cb2&scoped=true"
import script from "./reviewTrustForm.vue?vue&type=script&lang=js"
export * from "./reviewTrustForm.vue?vue&type=script&lang=js"

import "./reviewTrustForm.vue?vue&type=style&index=0&id=739c4cb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739c4cb2"]])

export default __exports__